import { inject, Service } from '@angular/core';
import { AnalyticsService } from '@app/core/services/mixpanel/analytics.service';
import { UserService } from '@app/core/services/user.service';
import { Company, User } from '@app/generated/graphql';

export type TSupportMenuAction = 'log_ticket' | 'view_docs';

@Service()
export class SupportMenuMixpanelEventTrackingService {
  private _analyticsService = inject(AnalyticsService);
  private _userService = inject(UserService);

  private _track(
    eventName: string,
    properties: Record<string, unknown> = {},
  ): void {
    const user: User = this._userService.getUserValue();
    const company: Company = this._userService.getCompanyValue();
    const timestamp: string = new Date().toISOString();

    if (!user || !company) {
      return;
    }

    this._analyticsService.track(eventName, {
      user_id: user.id,
      company_id: company.id,
      timestamp,
      ...properties,
    });
  }

  trackTooltipShown(): void {
    this._track('support_tooltip_shown');
  }

  trackTooltipDismissed(): void {
    this._track('support_tooltip_dismissed');
  }

  trackMenuOpened(): void {
    this._track('support_menu_opened');
  }

  trackActionClicked(action: TSupportMenuAction): void {
    this._track('support_menu_action_clicked', { action });
  }
}
